import * as React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { Box, Heading } from "@vinomofo/components";
import {
  isWhiskymofoDealsPage,
  isWhiskymofoSignupPage,
} from "../../utils/is-page";
import { BreadcrumbSchema } from "../breadcrumb";

type SEOProps = {
  title?: string;
  description?: string;
  pathname?: string;
  lang?: string;
  image?: string;
  type?: string;
  robots?: string;
};

const SEO: React.FC<SEOProps> = (props) => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          url
          lang
          image
          robots
          siteUrl
        }
      }
    }
  `);

  const { siteMetadata } = data.site;
  const { title, description, url, lang, image, robots } = siteMetadata;
  const siteTitle = props.title || title;
  const siteDescription = props.description || description;

  const isWhiskyDealsPage = isWhiskymofoDealsPage(props.pathname);
  const isWhiskySignupPage = isWhiskymofoSignupPage(props.pathname);

  const siteUrl = `${url}${props.pathname || ``}`;
  const siteLang = props.lang || lang;
  const siteImage = props.image || image;
  const siteType = props.type || "article";
  const siteRobots = props.robots || robots;
  //const siteKeywords = [...keywords, props.keywords].join(",");
  const metaData = [
    {
      name: "description",
      content: siteDescription,
    },
    {
      name: "title",
      content: siteTitle,
    },
    {
      name: "image",
      content: siteImage,
    },
    {
      property: "og:url",
      content: siteUrl,
    },
    {
      property: "og:type",
      content: siteType,
    },
    {
      property: "og:title",
      content: siteTitle,
    },
    {
      property: "og:description",
      content: siteDescription,
    },
    {
      property: "og:image",
      content: siteImage,
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: siteTitle,
    },
    {
      name: "twitter:description",
      content: siteDescription,
    },
    {
      name: "twitter:image",
      content: siteImage,
    },
    {
      name: "twitter:site",
      content: "@vinomofo",
    },
    // {
    //   name: "keywords",
    //   content: siteKeywords,
    // },
    {
      name: "robots",
      content: siteRobots,
    },
  ];

  return (
    <>
      <Helmet
        htmlAttributes={{ lang: siteLang }}
        title={siteTitle}
        titleTemplate={`%s | ${title}`}
        meta={metaData}
        link={[
          {
            rel: "canonical",
            key: siteUrl,
            href: siteUrl,
          },
          ...(props.pathname === "/"
            ? [
                {
                  rel: "alternate",
                  hrefLang: "en-au",
                  href: "https://www.vinomofo.com",
                },
                {
                  rel: "alternate",
                  hrefLang: "en-sg",
                  href: "https://www.vinomofo.com.sg",
                },
              ]
            : []),
        ]}
      />
      <BreadcrumbSchema pathname={props.pathname || ""} pageTitle={siteTitle} />
      {(isWhiskyDealsPage || isWhiskySignupPage) && (
        <Box display="none" aria-hidden="true">
          <Heading as="h1" variant="xl" textAlign="center">
            {isWhiskyDealsPage
              ? "Whisky Deals Online"
              : "Sign Up for Whisky Deals Online"}
          </Heading>
        </Box>
      )}
    </>
  );
};

export default SEO;
